import firebase from 'firebase';
require('firebase/firestore');
require("firebase/performance");

// const config = {
//   apiKey: "AIzaSyAv_k5TIRHFix6t0MkPShRAC9CWR0ARd9c",
//   authDomain: "taksy-pena-test.firebaseapp.com",
//   databaseURL: "https://taksy-pena-test.firebaseio.com",
//   projectId: "taksy-pena",
//   storageBucket: "taksy-pena.appspot.com",
//   messagingSenderId: "553838416898"
// };

const config = {
  apiKey: "AIzaSyAv_k5TIRHFix6t0MkPShRAC9CWR0ARd9c",
  authDomain: "taksy-pena.firebaseapp.com",
  databaseURL: "https://taksy-pena.firebaseio.com",
  projectId: "taksy-pena",
  storageBucket: "taksy-pena.appspot.com",
  messagingSenderId: "553838416898",
  appId: "1:553838416898:web:164ef202f19dda7325431b"
}

firebase.initializeApp(config);

const database = firebase.database();
const perf = firebase.performance();
export default database;



// WEBPACK FOOTER //
// ./src/Components/BD/database.js